import environment from 'environment';
import HttpErrorResponseModel from 'models/HttpErrorResponseModel';
import EffectUtility from 'utilities/EffectUtility';
import PersonResponse from './models/PersonResponse';

export default class RecipientEffect {
    public static async requestDoPhysicalNational(params?: any): Promise<PersonResponse | HttpErrorResponseModel> {
        const endpoint: string = environment.api.requestDoPhysicalNational;
        return EffectUtility.getToModel<PersonResponse>(PersonResponse, endpoint, params);
    }

    public static async requestDoPhysicalInternational(params?: any): Promise<PersonResponse | HttpErrorResponseModel> {
        const endpoint: string = environment.api.requestDoPhysicalForeing;
        return EffectUtility.getToModel<PersonResponse>(PersonResponse, endpoint, params);
    }

    public static async requestDoMoralNational(params?: any): Promise<PersonResponse | HttpErrorResponseModel> {
        const endpoint: string = environment.api.requestDoCompanyNational;
        return EffectUtility.getToModel<PersonResponse>(PersonResponse, endpoint, params);
    }

    public static async requestDoMoralInternational(params?: any): Promise<PersonResponse | HttpErrorResponseModel> {
        const endpoint: string = environment.api.requestDoCompanyForeing;
        return EffectUtility.getToModel<PersonResponse>(PersonResponse, endpoint, params);
    }

    public static async requestDoGetDataRecipient(params?: any): Promise<PersonResponse | HttpErrorResponseModel> {
        const endpoint: string = environment.api.requestDoGetDataRecipient;
        return EffectUtility.getToModel<PersonResponse>(PersonResponse, endpoint, params);
    }

    public static async requestDoDeleteRecipient(params?: any): Promise<PersonResponse | HttpErrorResponseModel> {
        const endpoint: string = environment.api.requestDoDeleteDataRecipient;
        return EffectUtility.deleteToModel<PersonResponse>(PersonResponse, endpoint, params);
    }
}
